define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/thunderxpay_form"
], function($, _, Marionette, CommonView, ThunderxpayForm) {
    return CommonView.extend({
        ui: _.extend(CommonView.prototype.ui, {
            'signature': '#signature',
            'signatureName': '#signature_name',
            'bankName': '#bank_name',
            'bankCode': '#bank_code',
            'currency': '#currency',
            'amount' : '#amount'
        }),

        events: _.extend(CommonView.prototype.events, {
            'keyup @ui.signatureName': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureName, this.ui.signature);
            },

            'keyup @ui.amount': 'updateExpected',
        }),

        initialize: function(){
            this.bindUIElements();
            this.delegateEvents();
            this.form = new ThunderxpayForm();

            // this.updateBankDetails();
        },

        updateExpected : function(e) {
            const currency = $('#currency_abbr').val();
            const amount = $('#amount').val();

            const fx_rate = window.fx_rates[currency];
            const amountUsd = (amount * fx_rate).toFixed(2);
            $('#expected_amount').text(`$ ${amountUsd}`);
        },

        updateSignature: function($signatureName, $signature){
            // Filter all characters that are not a-z A-Z
            $signatureName.val($signatureName.val().replace(/[^a-zA-Z0-9\s\-\_\,\.]/g, function(str){
                return '';
            }));

            $signature.val($signatureName.val());
        },
    });
});
